import React from 'react';

const builders = [
  { name: 'DLF', style: 'dlf', caption: 'LIMITED' },
  { name: 'LODHA', style: 'lodha', caption: 'WORLD HOMES' },
  { name: 'GODREJ', style: 'godrej', caption: 'PROPERTIES' },
  { name: 'PRESTIGE', style: 'prestige', caption: 'GROUP' },
  { name: 'SOBHA', style: 'sobha', caption: 'LIMITED' },
  { name: 'BRIGADE', style: 'brigade', caption: 'GROUP' },
];

function BuilderTrack({ copy }) {
  return (
    <div className="builder-track" aria-hidden={copy}>
      {builders.map((builder) => (
        <div className={`builder-logo builder-logo-${builder.style}`} key={`${copy ? 'copy-' : ''}${builder.style}`}>
          <span>{builder.name}</span>
          <small>{builder.caption}</small>
        </div>
      ))}
    </div>
  );
}

export default function NetworkBuilders() {
  return (
    <section className="network-builders-section" aria-labelledby="network-builders-title">
      <div className="network-builders-heading">
        <p className="eyebrow">A LANDSCAPE OF DISTINGUISHED NAMES</p>
        <h2 id="network-builders-title">Our Network Builders</h2>
        <p>Discover the names shaping India’s evolving property landscape.</p>
      </div>
      <div className="builder-logo-window" aria-label="Featured Indian real estate developers">
        <div className="builder-logo-motion">
          <BuilderTrack copy={false} />
          <BuilderTrack copy={true} />
        </div>
      </div>
      <p className="builder-logo-note">Developer names are shown for identification; this display does not imply affiliation.</p>
    </section>
  );
}
